import moment from 'moment/moment';
import { flatten } from 'lodash';
import timeplanUnitShouldBeExpanded from './timeplanUnitShouldBeExpanded';

/**
 * Expands timeplanUnits that cross midnight into two timeplanUnits
 * @param timeplanUnits
 * @param includeSourceId
 */
export default function expandedTimeplanUnits(timeplanUnits, includeSourceId = false) {
  if (!timeplanUnits) {
    return timeplanUnits;
  }

  return flatten(
    timeplanUnits.map(
      (timeplanUnit) => {
        if (!timeplanUnitShouldBeExpanded(timeplanUnit)) {
          return [timeplanUnit];
        }

        if (timeplanUnit.to === '00:00') {
          return [{
            ...timeplanUnit,
            to: '24:00',
          }];
        }

        return [
          {
            ...timeplanUnit,
            to: '24:00',
          },
          {
            ...timeplanUnit,
            ...(timeplanUnit.id ? { id: `${timeplanUnit.id}-spread` } : {}),
            from: '00:00',
            date: moment(timeplanUnit.date).add(1, 'day').format('YYYY-MM-DD'),
            ...(includeSourceId ? { sourceId: timeplanUnit.id } : {}),
          },
        ];
      },
    ),
  );
}
